import React, {useMemo, useState} from 'react';
import {ITracking} from 'api/transactions';
import Button from 'components/ui/Button';
import PaymentTimeline, {
    ITimelineEntry,
} from 'components/ui/PaymentTimeline/PaymentTimeline';
import {formatNumber} from 'helpers/common';
import {formatDateTime} from 'helpers/dates';
import FA from 'react-fontawesome';
import {translate} from 'helpers/localize';
import styles from './SwiftTracking.module.scss';

interface IProps {
    swiftTracking: ITracking;
    isLoading?: boolean;
    bankName?: string;
}

const SwiftTracking = ({swiftTracking, isLoading, bankName}: IProps) => {
    const [open, setOpen] = useState<boolean>(false);

    const createTimeline = useMemo((): ITimelineEntry[] => {
        const timeline: ITimelineEntry[] = [];

        if (swiftTracking && swiftTracking.events) {
            const isCompleted =
                swiftTracking.transaction_status === 'completed';
            [...swiftTracking.events]
                .sort((a, b) =>
                    new Date(a.last_update_time) > new Date(b.last_update_time)
                        ? 1
                        : -1,
                )
                .forEach((event, index) => {
                    const amount = event.confirmed
                        ? event.confirmed.amount
                        : event.instructed?.amount;
                    const currency = event.confirmed
                        ? event.confirmed.currency
                        : event.instructed?.currency;
                    timeline.push({
                        label: (
                            <span data-notranslate>
                                {formatDateTime(event.last_update_time)}
                            </span>
                        ),
                        comment: (
                            <div data-notranslate>
                                {`${formatNumber(amount)} ${currency} | ${
                                    event.from_name
                                }`}
                                <FA
                                    name="arrow-right"
                                    className={styles.arrowIcon}
                                />
                                {`${event.to_name}`}
                            </div>
                        ),
                        status: 'done',
                    });
                });

            if (!isCompleted && bankName) {
                timeline.push({
                    label: bankName,
                    comment: null,
                    status: 'pending',
                });
            }
        }
        return timeline;
    }, [swiftTracking, bankName]);

    return (
        <>
            <Button
                variant="text"
                icon={open ? 'chevron-up' : 'chevron-down'}
                iconPosition="right"
                onClick={() => setOpen(prev => !prev)}
            >
                {translate('More details')}
            </Button>
            {open ? (
                <PaymentTimeline size="xl" entries={createTimeline} />
            ) : null}
        </>
    );
};

export default SwiftTracking;
